import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    track("page_view", { title: document.title });
  }, [location.pathname, location.search]);
  return null;
}
